module.exports = __webpack_public_path__ + "static/media/czhdentry.2e7002bb.jpg";